/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=fed8ee86"
const script = {}

import exportComponent from "E:\\Rame_sms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__